import {createApp} from 'vue';
import {createRouter, createWebHistory} from 'vue-router';

/* Pinia */
import {createPinia} from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "./assets/js/color-modes";

/* Font Awesome */
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {library} from '@fortawesome/fontawesome-svg-core'
import {fas} from '@fortawesome/free-solid-svg-icons'
import {far} from '@fortawesome/free-regular-svg-icons'

import App from './App.vue';

import MainPage from "@/components/MainPage.vue";
import WeekView from "@/components/reservations/WeekView.vue";
import SpacesPage from "@/components/spaces/SpacesPage.vue";
import LoginPage from "@/components/user/LoginPage.vue";
import SignupPage from "@/components/user/SignupPage.vue";
import TermsConditionsPage from "@/components/user/TermsConditionsPage.vue";
import PrivacyPolicyPage from "@/components/user/PrivacyPolicyPage.vue";
import ActivationPage from "@/components/user/ActivationPage.vue";
import NotFoundPage from "@/components/NotFoundPage.vue";
import ProfilePage from "@/components/user/ProfilePage.vue";
import AdminDashboard from "@/components/admin/AdminDashboard.vue";
import { useAuthStore } from "@/stores/auth";

library.add(fas, far)

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {path: '/', component: MainPage},
        {path: '/rezerwacje', component: WeekView},
        {path: '/stanowiska', component: SpacesPage},
        {path: '/login', component: LoginPage},
        {path: '/signup', component: SignupPage},
        {path: '/regulamin', component: TermsConditionsPage},
        {path: '/polityka-prywatnosci', component: PrivacyPolicyPage},
        {path: '/user/activate', component: ActivationPage},
        {path: '/user/profile', component: ProfilePage},
        {path: '/admin/:section', component: AdminDashboard, meta: { requiresAdmin: true }},
        {path: '/:pathMatch(.*)*', component: NotFoundPage}
    ]
})

router.beforeEach((to, from, next) => {
    // Redirect base /admin or /admin/ directly to /admin/overview
    if (to.path === '/admin' || to.path === '/admin/') {
        return next('/admin/overview')
    }

    if (to.meta.requiresAdmin) {
        const authStore = useAuthStore()
        const user = authStore.user

        const isAdmin = user && (
            (Array.isArray(user.roles) && user.roles.some(r => r.role_id === 1 || r.name === 'admin'))
        )

        if (!user || !isAdmin) {
            return next('/404')
        }
    }
    next()
})

const app = createApp(App);
const pinia = createPinia()

pinia.use(piniaPluginPersistedstate)

app.component('font-awesome-icon', FontAwesomeIcon)

app.use(router);
app.use(pinia);

app.mount('#app');
